<ca-filter-panel
  #filterPanel
  [config]="filterPanelConfig"
  (valueChanges)="onFilterValueChanges($event)"
  (collapsed)="onFilterPanelCollapsed($event)"
  (expanded)="onFilterPanelExpanded($event)"
></ca-filter-panel>
